import { default as deserialize } from 'app/utils/deserialize'
import { create } from 'app/utils/data'
import FormErrors from 'app/utils/form_errors'

export default {
  namespaced: true,

  state: {},

  getters: {
    sendToBillingPortal: (state) => false
  },

  mutations: {
    resetState: (state) => state
  },

  actions: {
    async requestBillingPortal(_state, returnPath) {
      try {
        const response = await create({
          url: '/api/billing-portal/session',
          type: 'billing-portal-session',
          data: returnPath ? { returnPath } : {}
        })

        return await deserialize(response.data)
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    }
  }
}
